module.exports = __webpack_public_path__ + "img/672.a3e68cd8.png";